import React from "react";
import { TableCellLink } from "../../../components/table-components/TableCellLink";
import { TableCellText } from "../../../components/table-components/TableCellText";

type Props = {
  isCurrent: boolean;
  href: string;
  children: React.ReactNode;
};

export const ChallengesTableCell = ({ isCurrent, href, children }: Props) => {
  if (isCurrent) {
    return <TableCellLink href={href}>{children}</TableCellLink>;
  }
  return <TableCellText>{children}</TableCellText>;
};
